import { useHistory } from 'react-router-dom'

import BodySection from 'src/views/shippinginstruction/createsi/viewsidraft/BodySection'
import React from 'react'
import { components } from 'cng-web-lib'

const {
  form: { CngViewForm }
} = components

function ViewSIDetailsPage(props) {
  const history = useHistory()
  const {showNotification} = props
  
  function onSubmit(data) {
    console.log('submit edit')
  }

  return (

    <CngViewForm
      fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
      history={history}
      showNotification={showNotification}
      bodySection={
        <BodySection.FormFields
          disabled={false}
          helpdesk
          {...props}
        />
      }
      formikProps={{
        ...BodySection.formikProps,
        onSubmit: onSubmit
      }}

    />

  )
}

export default ViewSIDetailsPage
